/**
 * Push events to the GTM.
 * @param {string} step
 * @param {boolean} log
 */
export default (step, log = false) => {
    if (typeof window.dataLayer === 'undefined') return;

    window.dataLayer.push({
        'event': 'forms.show',
        'formType': window.croIdentifier,
        'step': step,
    });

    if (log === true) {
        console.log(window.dataLayer);
    }
};
